'use client';

import { Tooltip } from '@base-ui-components/react/tooltip';
import type * as React from 'react';
import { cn } from '../../lib/utils';

const TooltipProvider = Tooltip.Provider;

const TooltipRoot = Tooltip.Root;

const TooltipTrigger = Tooltip.Trigger;

function TooltipContent({
  className,
  sideOffset = 10,
  container,
  children,
  ...props
}: React.ComponentProps<typeof Tooltip.Popup> & {
  sideOffset?: number;
  container?: React.ComponentProps<typeof Tooltip.Portal>['container'];
}) {
  return (
    <Tooltip.Portal container={container}>
      <Tooltip.Positioner sideOffset={sideOffset}>
        <Tooltip.Popup
          className={cn(
            'z-50 overflow-hidden rounded-md border border-brand-burgundy bg-white px-3 py-1.5 text-brand-burgundy text-sm shadow-lg',
            'origin-[var(--transform-origin)]',
            'data-[starting-style]:scale-90 data-[starting-style]:opacity-0',
            'data-[ending-style]:scale-90 data-[ending-style]:opacity-0',
            'data-[instant]:duration-0',
            'transition-[transform,scale,opacity]',
            className
          )}
          {...props}
        >
          {children}
        </Tooltip.Popup>
      </Tooltip.Positioner>
    </Tooltip.Portal>
  );
}

export {
  TooltipRoot as Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
};
